"use client";
import { useState as u, useEffect as n } from "react";
import { registerStoryblokBridge as c } from "@storyblok/js";
const g = (e = null, s = {}) => {
  const [r, o] = u(e), d = (e == null ? void 0 : e.id) ?? 0, t = typeof window < "u" && typeof window.storyblokRegisterEvent < "u";
  return n(() => {
    o(e), !(!t || !e) && c(
      d,
      (f) => o(f),
      s
    );
  }, [e]), r;
};
export {
  g as useStoryblokState
};
